import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  SutResponse
} from '@eggplant/types'

interface Props {
  id: string
  onError?: (error: Error) => void
  onSuccess?: (response: SutResponse) => void
  children?: (response: SutResponse) => ReactElement
  shortErrorMessage?: string
}

const GetSutRequest = ({
  id,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${SUT_SERVICE}/suts/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSutRequest
